export class NewMessageModel {
  message: string;
  conversationId: number;

  constructor() {
    this.message = '';
    this.conversationId = 0;
  }
}
